import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

import { ResultSection } from 'aem-libs-react-components/src/components/calculators/components/result-section'

import { testIds } from '../e2e/testIds'
import { CtaButtons } from './CtaButtons'

const OutOfLimitsWrapper = styled.div`
  font-size: 16px;
  padding: 30px 70px;
  text-align: center;
`

export const OutOfLimitResult = ({ children }: PropsWithChildren<{}>) => {
  return (
    <ResultSection.Container testId={testIds.outOfLimitResultContainer}>
      <OutOfLimitsWrapper>{children}</OutOfLimitsWrapper>
      <CtaButtons testId={testIds.outOfLimitResultCta} />
    </ResultSection.Container>
  )
}
